// import slugIndex from '@/pages/slug/Index.vue';
// import slugPlan from '@/pages/slug/plan/Index.vue';

import { POST_LOG_COLLECT } from "@/api/config";
import * as $http from "@/api/fetch";

var is_first_Load = true;
// const new_client_view_name = [
//     "pPostId",
//     "albumAlbumId",
//     "albumAlbumIdPostId",
//     'uUserId',
//     "slug",
//     "slugPlan",
//     "orderCreate",
// ]; //拦截路由，改成客户端新view打开

function getReferrer(from) {
    if (is_first_Load) {
        is_first_Load = false;
        return document.referrer;
    }

    if (from && from.name) {
        return `${location.origin}${from.fullPath}`;
    } else {
        return `${location.origin}${from ? from.fullPath : ""}`;
    }
}
//打点
function log(to, from) {
    let init_config = localStorage.getItem("init_config");
    if (init_config) {
        let config = JSON.parse(init_config);
        let data = {
            stat_id: config.stat_id,
            uri: to ? `${location.origin}${to.fullPath}` : location.href,
            refer: getReferrer(from),
        };
        $http.$axios(POST_LOG_COLLECT, data);
    }
}

export function routerCustom(router) {
    // let custom_routes = [
    //     {
    //         "path": "/u/:userId",
    //         "component": slugIndex,
    //         "meta": {},
    //         "name": "slug"
    //     },
    //     {
    //         "path": "/u/:userId/plan",
    //         "component": slugPlan,
    //         "meta": {},
    //         "name": "slugPlan"
    //     },
    // ]
    // router.options.routes = custom_routes.concat(router.options.routes)
    router.beforeEach((to, from, next) => {
        //登录守卫
        let is_login = router.app.$cookies.get("auth_token");
        if (!is_login && to.meta.requiresAuth) {
            if (to && to.fullPath) {
                if (router.app.$store) {
                    router.app.$store.commit(
                        "app/set:redirect_url",
                        to.fullPath
                    );
                } else {
                    setTimeout(() => {
                        router.app.$store.commit(
                            "app/set:redirect_url",
                            to.fullPath
                        );
                    }, 200);
                }
            }
            router.log(to, from);
            next({ name: "login" });
            return false;
        }

        // if (router.app.$store) {
        //     if (router.app.$store.state.pageTransition.enable) {
        //         let effect = "fade";

        //         router.app.$store.commit("pageTransition/setType", "fade");
        //         router.app.$store.commit("pageTransition/setEffect", effect);
        //     }
        // }
        router.$from = from;
        // console.log(to.name);
        // (ENV.is_afd_client && router.app.$mixin_client_router)  ENV.is_beta &&
        // if (  ENV.is_beta && ENV.is_afd_client && router.app.$mixin_client_router) {
        //     if (new_client_view_name.indexOf(to.name) != -1) {
        //         next(router.app.$mixin_client_router(to));
        //         return false;
        //     }
        // }
        next();
    });

    router.log = function (to, from) {
        log(to, from);
    };

    router.afterEach((to, from) => {
        router.log(to, from);
        let is_login = router.app.$cookies.get("auth_token");
        if (!is_login && to.meta.requiresRedirect) {
            if (to && to.fullPath && router.app.$store) {
                router.app.$store.commit("app/set:redirect_url", to.fullPath);
            }
        }
    });

    return router;
}
